export enum FinancialDataTypeEnum {
  potentialRevenue = 1,
  potentialRevenuePlusAgreement = 2,
  expenseMDE = 3,
  revenueFUNDEB = 4
}
